// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"0660c42c","180":"91c8a996","216":"4bb3c6b1","453":"b62c0b96","499":"1bb4400f","524":"6e8789f0","960":"e7f94381"}[chunkId] + ".chunk.js";
};